"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTermsToAccept = void 0;
/**
 * @description Given a list of contracts, get the list of TermsAcceptance
 * for a specific template, e.g. vip_indirect_tc for initial VIP invite acceptance.
 *
 * @param contracts Array of Contracts
 * @param templateName Acceptance template name
 *
 * @returns List of terms to accept
 */

const getTermsToAccept = (contracts, templateName) => contracts.reduce((termsList, contract) => {
  var _a;

  const terms = (_a = contract.termsAcceptances) === null || _a === void 0 ? void 0 : _a.filter(termAcceptance => termAcceptance.needToAcceptTerms() && termAcceptance.templateName === templateName);

  if (terms) {
    termsList.push(...terms);
  }

  return termsList;
}, []);

exports.getTermsToAccept = getTermsToAccept;